$(document).ready(function(){
  // main-product featured_product
  $('.qty-pluss').click(function () {
    if ($(this).prev().val() < 6 ){
    $(this).prev().val(+$(this).prev().val() + 1);
    }
});
$('.qty-minuss').click(function () {
    if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
});
  // main-product featured_product end 
  $('.quantytyButtonplus').click(function () {
    if ($(this).prev().val() < 6 ){
    $(this).prev().val(+$(this).prev().val() + 1);
    }
});
$('.quantytyButtonMinus').click(function () {
    if ($(this).next().val() > 0) $(this).next().val(+$(this).next().val() - 1);
});
  // var new_quantity = $('.bunddle_quantity input').val();
  
  $('.bunddle_quantity button').on('click',function(){
   var new_quantity = $(this).parents('.bunddle_quantity').find('input').val();
    if(new_quantity > 0){
      $(this).parents('.bunddle-functionality').addClass('activate');
    }else{
       $(this).parents('.bunddle-functionality').removeClass('activate');
    }
  });
  var length_product = $('.bunddle-functionality.activate').length;
    if(length_product > 0 ){
      $('.featured-product--submit-action').addClass('bunddle_availabel');
      $('.featured-product--submit-action').removeClass('main_product');
    }
    else{
      $('.featured-product--submit-action').addClass('main_product');
      $('.featured-product--submit-action').removeClass('bunddle_availabel');
    }
  $(document).on('click','.quantity-controls.bunddle_quantity button',function(){
    var length_product = $('.bunddle-functionality.activate').length;
    if(length_product > 0 ){
      $('.featured-product--submit-action').addClass('bunddle_availabel');
      $('.featured-product--submit-action').removeClass('main_product');
    }
    else{
      $('.featured-product--submit-action').addClass('main_product');
      $('.featured-product--submit-action').removeClass('bunddle_availabel');
    }
  });
 // $(document).on('click','.custom_btn_bunddle',function(){
 //    var data_id_selected = {};
 //    data_id_selected['items'] = [];
 //    var data_key_truncate = Math.floor((Math.random() * 10000) + 1);   
 //   $('.bunddle-functionality.activate').each(function(){
 //     var product_id = $(this).attr('product-id');
 //     var product_quantity = $(this).find('.quantity-selector').val();
 //     var window_path = window.location.pathname;
 //     var this_sling_id = $(this).attr('selling-plan');
 //     // console.log(this_sling_id);
 //       data_id_selected['items'].push({
 //          "id": product_id,
 //          "quantity": product_quantity,
 //          "selling_plan":this_sling_id,
 //            "properties":{ 
 //              "Trinket-key":data_key_truncate,
 //            }
 //        });
  
 //   });
 //   $.ajax({
 //     type:"post",
 //     url:"/cart/add.js",
 //     data:data_id_selected,
 //     datatype:'json',
 //     success:function(){
 //        $('.custom_btn.btn').trigger('click');
 //       $('.featured-product--submit-action').removeClass('bunddle_availabel');
 //        $('.bunddle-functionality').removeClass('activate');
 //        $('.quantity-controls.bunddle_quantity input').val(0);
 //       // $(".cart-item-count-header").load(location.href + " .cart-item-count-header");
 //     }
 //   })
 //   $('[action="/cart/add"]').append("<input id='data_key' type='hidden' name='properties[Trinket-key-main]' value="+data_key_truncate+">");
 // });


$(document).on('click', '.custom_btn_bunddle', function() {  
    var data_id_selected = {};  
    data_id_selected['items'] = [];  
  
    var data_key_truncate = Math.floor((Math.random() * 1000000) + 1);   

    $('.bunddle-functionality.activate').each(function() {  
        
        var product_id = $(this).attr('product-id');  
        var product_quantity = $(this).find('.quantity-selector').val();  
        var this_sling_id = $(this).attr('selling-plan');   
        var itemData = {  
            "id": product_id,  
            "quantity": product_quantity,  
            "properties": {   
                "Trinket-key": data_key_truncate,  
            }  
        };  
        if (this_sling_id) {  
            itemData.selling_plan = this_sling_id;  
        }  
        data_id_selected['items'].push(itemData); 

        
    });  
    console.log(data_id_selected);
    $.ajax({  
        type: "post",  
        url: "/cart/add.js",  
        data: data_id_selected,  
        datatype: 'json',  
        success: function() {  
            $('.custom_btn.btn').trigger('click');  
            $('.featured-product--submit-action').removeClass('bunddle_availabel');  
            $('.bunddle-functionality').removeClass('activate');  
            $('.quantity-controls.bunddle_quantity input').val(0);  
            // $(".cart-item-count-header").load(location.href + " .cart-item-count-header");  
        }  
    });  

    $('[action="/cart/add"]').append("<input id='data_key' type='hidden' name='properties[Trinket-key-main]' value=" + data_key_truncate + ">");  
});
  
  $(document).on('change','select.sls-select',function(){
    setTimeout(function() { 
     var data_change_price = $('.sls-option-container').not('.newone_one0').find('.sls-price span.money.conversion-bear-money').text();
      $('.product-page--pricing--variant-price .money').html(data_change_price);
    console.log(data_change_price);
       }, 100);
    setTimeout(function() { 
      var data_price = $('li.product-page--pricing--variant-price .money').html();
      $('.main-product').html(data_price);
      var new_data_price = data_price.split('$');
      var new_data_price_new = new_data_price[1];
    $('.main-product').attr('data-price',new_data_price_new);
      $(document).find('.button_custom').trigger('click');
    }, 500);
   var new_class = $(this).find('option:selected').html();
  });
  $(document).on('click','.sls-option-container.seal-table',function(){
    var data_value = $('.sls-purchase-options-container [name="selling_plan"]').attr('value');
    if (data_value == ''){
      $('.sales_selected_shiping').html('');
    }
    else{
    }
  });
 setTimeout (function(){
      $('.sls-selling-plan-group-first-liner').append('<div class="free_shiping_s"><span>Free Shiping</span></div>');
   var matches = document.querySelectorAll(".sls-option-container");
matches.forEach(function(element,index){
		// console.log(index);
		element.classList.add('newone_one' + index);
		element.setAttribute("data-index", index);
		if(index == 0){
         // div.innerHTML += 'Extra stuff';
          // element.innerHTML += '+ shipping';
		}else if(index == 1){
          
        }	
	});
  },4000);
  $(document).on('click', '.button_qu' ,function () {
      var qunatity = $('.quantity-selector').val();
    var current_price = $('li.product-page--pricing--variant-price .money').html();
    var new_data_price = current_price.split('$');
    var new_data_price_new = new_data_price[1];
    var new_price_with = qunatity * new_data_price_new;
    var doller = '$';
    $('.main-product').html(doller + new_price_with );
});
  $(document).on('click', '.button_qu' ,function () {
      var qunatity = $('.quantity-selector').val();
    var current_price = $('.no_discount').attr('data-price');
    // var new_data_price = current_price.split('$');
    // var new_data_price_new = new_data_price[1];
    var new_price_with = qunatity * current_price;
    var doller = '$';
    $('.no_discount').html(doller + new_price_with );
});
  // $(document).on('click','.button_qu',function(){
  //      var prices = [];
  //    $('.activate .price_tru').each(function() {
  //           var priceText = $(this).text().replace('$', '');
  //           var price = parseFloat(priceText); 
  //           prices.push(price); 
  //       });
  //   var totalPrice = prices.reduce(function(sum, price) {
  //           return sum + price;
  //       }, 0);
  //    $('.total-price-with-trunkate').text('$' + totalPrice.toFixed(2));
  //   $('.sls-option-container').not('.newone_one0').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
  //   // $('.sls-option-container').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
  //   // console.log(prices);
   
  // });
  // $(document).on('click','.button_qu',function(){
  //      var prices = [];
  //    $('.activate .origanl_price').each(function() {
  //           var priceText = $(this).text().replace('$', '');
  //           var price = parseFloat(priceText); 
  //           prices.push(price); 
  //       });
  //   var totalPrice = prices.reduce(function(sum, price) {
  //           return sum + price;
  //       }, 0);
  //    $('.total-price-with-trunkate').text('$' + totalPrice.toFixed(2));
  //   $('.sls-option-container.newone_one0').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
  //   // $('.sls-option-container').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
  //   // console.log(prices);
   
  // });


  // testing code discount price code 

if(window.location.pathname == '/pages/landing-page-subscription'){
  
  $(document).on('click','.button_qu',function(){
      var prices = [];
      $('.activate .price_tru').each(function() {
          var priceText = $(this).text().replace('$', '');
          var price = parseFloat(priceText); 
          prices.push(price); 
      });
      var totalPrice = prices.reduce(function(sum, price) {
          return sum + price;
      }, 0);
      console.log(totalPrice);
      var discountedPrice = totalPrice; // applying 10% discount
      $('.price_compaire_at').text('$' + totalPrice.toFixed(2));
      $('.total-price-with-trunkate').text('$' + discountedPrice.toFixed(2));
      $('.sls-option-container').not('.newone_one0').find('.sls-price span.money.conversion-bear-money').text('$' + discountedPrice.toFixed(2));
  });
  
  
  $(document).on('click','.button_qu',function(){
      var prices = [];
      $('.activate .origanl_price').each(function() {
          var priceText = $(this).text().replace('$', '');
          var price = parseFloat(priceText); 
          prices.push(price); 
      });
      var totalPrice = prices.reduce(function(sum, price) {
          return sum + price;
      }, 0);
      
      var discountedPrice = totalPrice ; // applying 10% discount
      
      $('.total-price-with-trunkate').text('$' + discountedPrice.toFixed(2));
      $('.sls-option-container.newone_one0').find('.sls-price span.money.conversion-bear-money').text('$' + discountedPrice.toFixed(2));
  });

}else{

$(document).on('click','.button_qu',function(){
       var prices = [];
     $('.activate .price_tru').each(function() {
            var priceText = $(this).text().replace('$', '');
            var price = parseFloat(priceText); 
            prices.push(price); 
        });
    var totalPrice = prices.reduce(function(sum, price) {
            return sum + price;
        }, 0);
     $('.total-price-with-trunkate').text('$' + totalPrice.toFixed(2));
    $('.sls-option-container').not('.newone_one0').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
    // $('.sls-option-container').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
    // console.log(prices);
   
  });
  
   $(document).on('click','.button_qu',function(){
       var prices = [];
     $('.activate .origanl_price').each(function() {
            var priceText = $(this).text().replace('$', '');
            var price = parseFloat(priceText); 
            prices.push(price); 
        });
    var totalPrice = prices.reduce(function(sum, price) {
            return sum + price;
        }, 0);
     $('.total-price-with-trunkate').text('$' + totalPrice.toFixed(2));
    $('.sls-option-container.newone_one0').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
    // $('.sls-option-container').find('.sls-price span.money.conversion-bear-money').text('$' + totalPrice.toFixed(2));
    // console.log(prices);
   
  });
}
  // testing code close discount price code  '^'





  
  $(document).on('click','.sls-option-container',function(){
       var prices = [];
     $('.activate .price_tru').each(function() {
            var priceText = $(this).text().replace('$', '');
            var price = parseFloat(priceText); 
            prices.push(price); 
        });
    var totalPrice = prices.reduce(function(sum, price) {
            return sum + price;
        }, 0);
    // $(document).find('.sls-option-container span.money.conversion-bear-money').css('opacity','0');
   setTimeout(function() { 
      $(document).find('.button_custom').trigger('click');
   }, 500);

    var data_selling = $(this).find('select.sls-select option').val();
    console.log(data_selling);
    $('.product_selling_grups input').each(function(){
     var value_this = $(this).val();
      console.log(value_this);
      if(data_selling == value_this){
        $(this).attr('checked','checked');
      }else{
        $(this).removeAttr('checked','checked');
      }
    });
    
  });
  $(document).on('change','.variants_product input',function(){
    $(this).addClass('activate_truncate');
    $(this).not('input[type=checkbox]:checked').removeClass('activate_truncate');
  });
  $(document).on('click','.cust-itg_disabl',function(){
    var index_ing = $('.activate_truncate').length;
    var data_id_selected = {};
    data_id_selected['items'] = [];
    // console.log(data_id_selected);
    if(index_ing > 0 ){
      $('.activate_truncate').each(function(index){
        var product_truncate_id = $(this).attr('variants');
        // console.log(product_truncate_id);
        data_id_selected['items'].push({
          "id": product_truncate_id,
          "quantity": 1,
           });
      });
     $.ajax({
     type:"post",
     url:"/cart/add.js",
     data:data_id_selected,
     datatype:'json',
     success:function(){
        setTimeout (function(){
         window.location.href ='/cart';
        },700);
     }
   }) 
    }else{
      setTimeout (function(){
        window.location.href ='/cart';
      },2000);
    }
  });
  $('.custom-img_fetured').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    adaptiveHeight: true,
    cssEase: 'linear'
  });
  $('.swiper_container_fetured_product').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    adaptiveHeight: true,
    cssEase: 'linear'
  });
  $(document).find('.cust-itg_disabl').removeAttr("disabled");

  function moveAlong() {
    var bundleHandle = $(document).find('.bundle_product_list').data('handle');
    
    var var_id = [];     
    $('.product_list').each(function() {
        var variant = $(this).attr('data-variant-id');
        if (variant) { 
          var_id.push(variant);
        }
    });

    var product_data = var_id.map(function(id) {
        return { 
            "id": id, 
            "quantity": 1, 
            "properties": {
                "bundleHandle": bundleHandle
            }
        };
    });

    var data = {
        items: product_data
    };

    // Using Shopify's `fetch` API for adding items to the cart
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then(response => {
        window.wetheme.updateCartDrawer(response);
        $('.upper_hidden_button .cust-itg_disabl').trigger('click');
         setTimeout(function(){
           $(document).find('.childProduct').find('.cart-item-link').removeAttr('href');
          },2000);
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

  
  $(document).on('click','.add_tocart_button button',function(){
    var data_btn = $(this).data('btn');
    if(data_btn == 'main'){
      
      var bundleHandle = $(document).find('.bundle_product_list').data('handle');
      $('.upper_hidden_button .cust-itg_disabl').trigger('click');
    //   if(!bundleHandle){
    //   $('.upper_hidden_button .cust-itg_disabl').trigger('click');
    //   }else{
    //   // moveAlong();
    // }
    }else{
       $('.upper_hidden_button .custom_btn_bunddle').trigger('click');
    }
    
  });
    $('.main_mobile_quanityty .qty-btn-plus').click(function () {
      if ($(this).prev().val() < 6 ){
        $(this).prev().val(+$(this).prev().val() + 1);
      }
      $('.main-qunatity-_plus_-Subscriptions_div .qty-pluss').trigger('click');
    });
    $('.main_mobile_quanityty .qty-btn-minus').click(function () {
      if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
      $('.main-qunatity-_plus_-Subscriptions_div .qty-minuss').trigger('click');
    });
  $('main#main .shopify-section').each(function(elements,index){
    $(this).addClass("same_shopify"); 
  });
  // custom css plan change css 
  $(document).on('change','.product_selling_grups input',function(){
    var this_plan = $(this).data('selling');
    $('.product_selling_grups_main input').each(function(){
     var this_plan_each = $(this).data('selling');
      if(this_plan == this_plan_each){
        $(this).attr('checked','checked');
        $(this).trigger('click');
      }else{
        $(this).removeAttr('checked','checked');
      }
    });
  });
});
// $(document).find('.image_center_footer img').parents('.shopify-section ').siblings().addClass('check_color');
var matches = document.querySelectorAll("main#main .shopify-section");
var numbers = []
  matches.forEach(function(element,index){
    numbers.push(index)
    element.setAttribute("data-index", index);
  });
let max = numbers[0];
for (let i = 1; i < numbers.length; i++) {
    if (numbers[i] > max) {
        max = numbers[i];
    }
}
$('main#main .shopify-section').each(function(elements,index){
    var data_attr = $(this).data('index');
  if(data_attr == max){
    $(this).find('section').addClass('check_color');
  }else{
     $(this).find('section').removeClass('check_color');
  }
});
// console.log(max);

const element = document.querySelector('.check_color')
const style = getComputedStyle(element)
const backgroundColor = style.backgroundColor
console.log(backgroundColor)
if(backgroundColor == 'rgba(0, 0, 0, 0)'){
  $(document).find('.image_center_footer img').css('background','#fff');
}
else{
  $(document).find('.image_center_footer img').css('background',backgroundColor);
}



